<template>
  <div class="relative pb-16 lg:pb-1 lg:mb-8">
    <UiContentwrapper v-if="highlightsArticle" class="pt-11 lg:pt-12 mb-3 pb-3 lg:mb-8 lg:pb-12">
      <UiNarrowcolumn>
        <h2 class="mb-2 lg:mb-4" v-html="highlightsArticle.title" />

        <div v-html="highlightsArticle.contenthtml" />


        <div class="hidden  w-full lg:flex justify-end transform -translate-y-full">
          <NuxtLink :to="extractLink(highlightsArticle.excerpthtml)">
            <UiRippleButton class="brown">
              {{ highlightsArticle.excerpt }}
            </UiRippleButton>
          </NuxtLink>
        </div>

      </UiNarrowcolumn>
    </UiContentwrapper>
  </div>
</template>

<script setup>

import { useBlogStore } from '@/stores/blogStore';
const UiRippleButton = defineAsyncComponent(() => import('@/components/ui/RippleButton.vue'));

// Get the blog store
const blogStore = useBlogStore();
var highlightsArticle = ref(null);



onMounted(async () => {

  try {
    highlightsArticle.value = await blogStore.getArticleByHandle('gravaa-highlights');
  }
  catch (err) {
    console.error('Error fetching gravaa-highlights:', err);
  }

});


// Method to extract link from excerpt
const extractLink = (excerpt) => {
  const linkMatch = excerpt.match(/href="([^"]*)"/);
  return linkMatch ? linkMatch[1] : '#';
};
</script>

<style scoped>
@reference "../../assets/css/main.css";


:deep(li) {
  @apply relative pl-8 text-black leading-tight before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2 before:w-3 before:h-3 before:bg-black before:rounded-full border-b border-black block w-fit whitespace-normal pt-5 pb-6 my-0 text-base lg:text-2xl;
}
</style>